import { apiFetch } from '../apiFetch'
import type { PoSigner } from '@/features/purchasing/PoSignerEditor'

export type PoSignersSettings = { signers: PoSigner[]; configured: boolean }

export async function getPoSignersSettings(): Promise<PoSignersSettings> {
  const response = await apiFetch('/api/settings/po-signers')
  const body = await response.json() as { ok: boolean; data: PoSigner[]; configured?: boolean; error?: { message?: string } }
  if (!response.ok) throw new Error(body.error?.message || 'Không tải được mặc định người ký')
  return { signers: body.data, configured: body.configured === true }
}

export async function savePoSignersSettings(signers: PoSigner[]): Promise<PoSignersSettings> {
  const response = await apiFetch('/api/settings/po-signers', {
    method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ signers }),
  })
  const body = await response.json() as { ok: boolean; data: PoSigner[]; error?: { message?: string } }
  if (!response.ok) throw new Error(body.error?.message || 'Không lưu được mặc định người ký')
  return { signers: body.data, configured: true }
}
